import React, {FC, useState} from 'react';
import {withRouter} from '~/providers/with-router.tsx';
import RouteGuard from '@touchnet/react-route-guard';

import CommonWorktagTable from '../worktags/common-worktag-table';
import {useSelector} from "react-redux";
import Selectors from "~/state/selectors.ts";
import {CommonWorktag} from "~/types/common-worktag-type.ts";

export const CommonWorktagsLayout: FC = () => {
    const [commonWorktagsDirty, setCommonWorktagsDirty] = useState(false);
    const currentCommonWorktags: CommonWorktag[] = useSelector(Selectors.getCurrentCommonWorktags);
    const worktags: string[] = useSelector(Selectors.getWorktags);

    return (
        <React.Fragment>
            <CommonWorktagTable
                worktags={worktags}
                currentCommonWorktags={currentCommonWorktags}
                commonWorktagsDirty={commonWorktagsDirty} 
                setCommonWorktagsDirty={setCommonWorktagsDirty} 
            />
            <RouteGuard condition={commonWorktagsDirty}>
                {"You have unsaved changes. Are you sure you want to leave the page?"}
            </RouteGuard>
        </React.Fragment>
    );
}

export default withRouter(CommonWorktagsLayout);
